import { Controller } from 'stimulus'

// Submits a field's form when the field changes, so inline costing fields
// save without an explicit button. Works both when the controller sits on
// the form itself and when it wraps inputs tied to a form elsewhere via the
// HTML form="" attribute (needed for rows whose cells span table columns).
// requestSubmit (not submit) fires a real submit event, so rails-ujs picks
// up remote forms and saves them over XHR instead of a full page load.
// Submits debounce per form so stepper-arrow clicks accumulate into one save.
// Usage: <form data-controller="submit-on-change">
//          <input data-action="change->submit-on-change#submit">
export default class extends Controller {
  initialize() {
    this.timers = new Map()
  }

  submit(event) {
    const form = (event && event.target && event.target.form) || this.element
    clearTimeout(this.timers.get(form))
    this.timers.set(form, setTimeout(() => {
      this.timers.delete(form)
      if (!form.isConnected) return
      if (form.requestSubmit) {
        form.requestSubmit()
      } else {
        form.submit()
      }
    }, 400))
  }
}
